import { defineMessages } from 'react-intl';

// Main route
const groupsScope = 't.page.groups';

// Global scope
const globalScope = 't.global';

// Navigation
const navigationScope = 't.component.PortalAppNavigation';

// Global errors
const globalErrorsScope = 't.global.error';

export default defineMessages({
	// Group Scope
	successfullyDelete: {
		id: `${groupsScope}.successfullyDelete`,
		defaultMessage: 'Gruppo eliminato con successo',
	},
	failureDelete: {
		id: `${groupsScope}.failureDelete`,
		defaultMessage: 'Eliminazione gruppo fallita',
	},
	deleteSubtitle: {
		id: `${groupsScope}.deleteSubtitle`,
		defaultMessage: 'del gruppo',
	},
	detailTitle: {
		id: `${groupsScope}.detailTitle`,
		defaultMessage: 'Dettaglio gruppo',
	},
	groupEditing: {
		id: `${groupsScope}.groupEditing`,
		defaultMessage: 'Modifica gruppo',
	},
	groupCreation: {
		id: `${groupsScope}.groupCreation`,
		defaultMessage: 'Crea gruppo',
	},
	newGroupTitle: {
		id: `${groupsScope}.newGroupTitle`,
		defaultMessage: 'Inserisci i dati del gruppo',
	},
	groupCreatedSuccessfully: {
		id: `${groupsScope}.groupCreatedSuccessfully`,
		defaultMessage: 'Utente creato con successo',
	},
	groupNotCreatedSuccessfully: {
		id: `${groupsScope}.groupNotCreatedSuccessfully`,
		defaultMessage: 'Creazione utente fallita',
	},
	groupUpdatedSuccessfully: {
		id: `${groupsScope}.groupUpdatedSuccessfully`,
		defaultMessage: 'Gruppo modificato con successo',
	},
	groupUpdatedNotSuccessfully: {
		id: `${groupsScope}.groupUpdatedNotSuccessfully`,
		defaultMessage: 'Modifica gruppo fallita',
	},
	goBackModalButton: {
		id: `${groupsScope}.goBackModalButton`,
		defaultMessage: "Torna all'elenco gruppi",
	},

	// Navigation Scope
	pageTitle: {
		id: `${navigationScope}.groups.groupsList`,
		defaultMessage: 'Elenco Gruppi',
	},
	newGroup: {
		id: `${navigationScope}.groups.groupManagement`,
		defaultMessage: 'Crea Gruppo',
	},

	// Global Scope
	cap: {
		id: `${globalScope}.cap`,
		defaultMessage: 'Cap',
	},
	address: {
		id: `${globalScope}.address`,
		defaultMessage: 'Indirizzo',
	},
	county: {
		id: `${globalScope}.county`,
		defaultMessage: 'Provincia',
	},
	country: {
		id: `${globalScope}.country`,
		defaultMessage: 'Nazione',
	},
	personalData: {
		id: `${globalScope}.personalData`,
		defaultMessage: 'Dati anagrafici',
	},
	id: {
		id: `${globalScope}.id`,
		defaultMessage: 'ID',
	},
	name: {
		id: `${globalScope}.name`,
		defaultMessage: 'Nome',
	},
	creationDate: {
		id: `${globalScope}.creationDate`,
		defaultMessage: 'Data creazione',
	},
	lastUpdateDate: {
		id: `${globalScope}.lastUpdateDate`,
		defaultMessage: 'Data ultimo aggiornamento',
	},
	abortLabelButton: {
		id: `${globalScope}.abort`,
		defaultMessage: 'Annulla',
	},
	createLabelButton: {
		id: `${globalScope}.create`,
		defaultMessage: 'Crea',
	},
	confirmLabelButton: {
		id: `${globalScope}.confirm`,
		defaultMessage: 'Conferma',
	},
	saveLabelButton: {
		id: `${globalScope}.save`,
		defaultMessage: 'Salva',
	},
	emptyString: {
		id: `${globalScope}.emptyString`,
		defaultMessage: ' ',
	},
	edit: {
		id: `${globalScope}.edit`,
		defaultMessage: 'Modifica',
	},
	warning: {
		id: `${globalScope}.warning`,
		defaultMessage: 'Attenzione',
	},
	subtitleDelete: {
		id: `${globalScope}.subtitleDelete`,
		defaultMessage: 'Sei sicuro di voler procedere alla cancellazione {element}?',
	},
	invalidDate: {
		id: `${globalScope}.error.invalidDate`,
		defaultMessage: 'Data non valida',
	},
	theSecondDateIsMinorThanFirst: {
		id: `${globalScope}.error.theSecondDateIsMinorThanFirst`,
		defaultMessage: 'Data di fine troppo piccola',
	},
	fillFirstDateToContinueValidation: {
		id: `${globalScope}.error.fillFirstDateToContinueValidation`,
		defaultMessage: "Data d'inizio mancante",
	},
	city: {
		id: `${globalScope}.city`,
		defaultMessage: 'Città',
	},

	//Global Errors
	fieldRequested: {
		id: `${globalErrorsScope}.fieldRequested`,
		defaultMessage: 'Campo obbligatorio',
	},
	maxLength: {
		id: `${globalErrorsScope}.maxLength`,
		defaultMessage: 'Superata lunghezza massima',
	},
});
